<div id="labs">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class=" inner-card">
                    <h4 class="card-title ">Self Management Lab</h4>
                    <div class="card-body text-justify">
                        <div class="row">
                          <div class="col-6 text-center mb-4">
                            <a href="/assets/img/labs/self-management/1.jpg" data-lightbox="Self Management"><img src="/assets/img/labs/self-management/1.jpg" alt="Self Management" class="img-fluid rounded"></a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

       
    </div>
</div>